import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Tab, Nav, Table, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import MyApiClient from "../../../../../api-client/MyApiClient";
import segnalaMancanti from "../../../../components/Util/campiMancanti";

// Stati della squadra nella tendina: Sospesa e Conclusa si vedono ma non si scelgono da qui
const STATI_SQUADRA_TENDINA = [
    { value: 'ACTIVE', label: 'Attiva', tono: 'attivo' },
    { value: 'INACTIVE', label: 'Non attiva', tono: 'non-attivo' },
    { value: 'SUSPENDED', label: 'Sospesa', tono: 'non-attivo', disabled: true },
    { value: 'COMPLETED', label: 'Conclusa', tono: 'neutro', disabled: true },
];

export const AdminUserCoursesTeamsView = () => {
    const { id } = useParams();

    const [loadingShowed, setLoadingShowed] = useState(false);
    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [teamData, setTeamData] = useState(null);

    // Titolo della pagina = nome della squadra, appena caricato.
    usePageTitle(teamData?.name || teamData?.teamName);
    // Stato della squadra nella tendina accanto al titolo: si salva subito (regola SUI), come nella scheda
    // della struttura. Una bozza mostra «Bozza» e si attiva dalla modifica della squadra.
    const cambiaStatoSquadra = async (nuovo) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const result = await new MyApiClient().updateCourseTeam(token, id, { status: nuovo });
        if (result && result.error) return { error: result.error };
        setTeamData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!teamData?.status,
        bozza: teamData?.status === 'DRAFT',
        stati: STATI_SQUADRA_TENDINA,
        valore: teamData?.status,
        onCambia: cambiaStatoSquadra,
    });
    const [members, setMembers] = useState([]);
    const [membersLoading, setMembersLoading] = useState(false);
    const [slotBookings, setSlotBookings] = useState([]);
    const [slotBookingsLoading, setSlotBookingsLoading] = useState(false);
    const [courseData, setCourseData] = useState(null);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [addMemberModalShowed, setAddMemberModalShowed] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [addingMember, setAddingMember] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const courseTeams = await apiClient.getBookingCourseTeams(token);
                    setLoadingShowed(false);
                    
                    if (courseTeams && courseTeams.length > 0) {
                        // Trova il team specifico per ID
                        const team = courseTeams.find(team => team.id === id);
                        if (team) {
                            setTeamData(team);
                            // Fetch course data to check if it's OPEN
                            if (team.bookingCourseId) {
                                fetchCourseData(token, team.bookingCourseId);
                            }
                        } else {
                            setModalTitle("Errore");
                            setModalText("Team non trovato");
                            setModalShowed(true);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoadingShowed(false);
                setModalTitle("Errore");
                setModalText("Errore durante il caricamento dei dati");
                setModalShowed(true);
            }
        };

        fetchData();
    }, [id]);

    const fetchCourseData = async (token, courseId) => {
        try {
            const apiClient = new MyApiClient();
            const course = await apiClient.getBookingCourseById(token, courseId);
            setCourseData(course);
        } catch (error) {
            console.error('Error fetching course data:', error);
        }
    };

    const fetchAvailableUsers = async () => {
        if (!teamData?.bookingCourseId) return;
        
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                const userCourses = await apiClient.getUserBookingCourses(token);
                
                // Filter users who bought the same course and are not already in the team
                const currentMemberIds = members.map(member => member.userId);
                const eligibleUsers = userCourses.filter(userCourse => {
                    const userId = userCourse.juniorId || userCourse.playerId;
                    return userCourse.course_id === teamData.bookingCourseId && 
                           !currentMemberIds.includes(userId);
                });
                
                setAvailableUsers(eligibleUsers);
            }
        } catch (error) {
            console.error('Error fetching available users:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento degli utenti disponibili");
            setModalShowed(true);
        }
    };

    const addMemberToTeam = async () => {
        if (segnalaMancanti(!selectedUserId ? [{ campo: 'ct-utente', messaggio: 'Manca l\'utente da aggiungere' }] : []) > 0) return;
        
        setAddingMember(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                await apiClient.addMemberToTeam(token, id, { userId: selectedUserId });
                
                setAddMemberModalShowed(false);
                setSelectedUserId('');
                
                // Refresh members list
                fetchMembers();
                
                setModalTitle("Successo");
                setModalText("Membro aggiunto con successo alla squadra");
                setModalShowed(true);
            }
        } catch (error) {
            console.error('Error adding member to team:', error);
            setModalTitle("Errore");
            setModalText("Errore nell'aggiunta del membro alla squadra");
            setModalShowed(true);
        } finally {
            setAddingMember(false);
        }
    };

    const handleAddMemberClick = () => {
        fetchAvailableUsers();
        setAddMemberModalShowed(true);
    };

    const canAddMembers = () => {
        return false;
    };

    const fetchMembers = async () => {
        setMembersLoading(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                const response = await apiClient.getBookingCourseTeamMembers(token, id);
                setMembers(response || []);
            }
        } catch (error) {
            console.error('Error fetching members:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento dei membri");
            setModalShowed(true);
        } finally {
            setMembersLoading(false);
        }
    };

    const fetchSlotBookings = async () => {
        if (!id) return;
        
        setSlotBookingsLoading(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                const slotBookingsData = await apiClient.getTeamSlotBookings(token, id);
                setSlotBookings(slotBookingsData || []);
            }
        } catch (error) {
            console.error('Error fetching slot bookings:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento della pianificazione");
            setModalShowed(true);
        } finally {
            setSlotBookingsLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('it-IT');
    };

    const formatDateTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getDayOfWeek = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
        return days[date.getDay()];
    };

    if (!teamData) {
        return (
            <>
                <Modal className="fade" show={loadingShowed} centered>
                    <Modal.Body className="text-center">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        <div>Caricamento in corso...</div>
                    </Modal.Body>
                </Modal>

                <Modal className="fade" show={modalShowed} centered>
                    <Modal.Header>
                        <Modal.Title>{modalTitle}</Modal.Title>
                        <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <Row><Col className="col-xl-64">{modalText}</Col></Row>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-between">
                        <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                            Chiudi
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    const tabData = [
        {
            id: "informazioni",
            name: "Informazioni generali",
            content: (
                <Card>
                    <Card.Header><h4 className="card-title">Informazioni generali Squadra</h4></Card.Header>
                    <Card.Body>
                        <Row>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Nome Squadra:</strong>
                                    <div className="mt-1">{teamData.name || teamData.teamName}</div>
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Corso associato:</strong>
                                    <div className="mt-1">{courseData?.name || 'Caricamento...'}</div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Staff tecnico:</strong>
                                    <div className="mt-1">{teamData.coach?.firstName ? `${teamData.coach.firstName} ${teamData.coach.lastName}` : teamData.coachName}</div>
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Impianto:</strong>
                                    <div className="mt-1">{teamData.venueName || 'Non specificato'}</div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Numero Membri:</strong>
                                    <div className="mt-1">{teamData.membersIds.length} / {teamData.maxMembers}</div>
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Descrizione:</strong>
                                    <div className="mt-1" style={{whiteSpace: 'pre-line'}}>{teamData.description || 'Nessuna descrizione disponibile'}</div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Data Inizio:</strong>
                                    <div className="mt-1">{formatDate(teamData.startDate)}</div>
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <strong>Data Fine:</strong>
                                    <div className="mt-1">{formatDate(teamData.endDate)}</div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )
        },
        {
            id: "membri",
            name: "Membri",
            content: (
                <Card>
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">Componenti della squadra</h4>
                            {canAddMembers() && (
                                <Button 
                                    variant="primary" 
                                    size="sm" 
                                    style={{marginLeft: '10px'}}
                                    onClick={handleAddMemberClick}
                                >
                                    Aggiungi membro
                                </Button>
                            )}
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {membersLoading ? (
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Caricamento membri...</p>
                            </div>
                        ) : (
                            <Table responsive striped>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Cognome</th>
                                        <th>Tipo Utente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {members.length > 0 ? (
                                        members.map((member, index) => (
                                            <tr key={member.userId || index}>
                                                <td>{member.firstName}</td>
                                                <td>{member.lastName}</td>
                                                <td>
                                                    <span className={`badge badge-${member.userType === 'PLAYER' ? 'primary' : member.userType === 'JUNIOR' ? 'info' : 'secondary'}`}>
                                                        {member.userType}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center">Nessun membro trovato</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>
            )
        },
        {
            id: "pianificazione",
            name: "Pianificazione",
            content: (
                <Card>
                    <Card.Header><h4 className="card-title">Pianificazione attività della squadra</h4></Card.Header>
                    <Card.Body>
                        {slotBookingsLoading ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                                <div>Caricamento slot bookings...</div>
                            </div>
                        ) : (
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Giorno</th>
                                        <th>Data Inizio</th>
                                        <th>Data Fine</th>
                                        <th>Stato</th>
                                        <th>Corso</th>
                                        <th>Staff tecnico</th>
                                        <th>Impianto</th>
                                        <th>Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {slotBookings.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">Nessuna seduta a calendario.</td>
                                        </tr>
                                    ) : (
                                        slotBookings.map((booking, index) => (
                                            <tr key={booking.id || index}>
                                                <td><strong>{getDayOfWeek(booking.startDateTime)}</strong></td>
                                                <td>{formatDateTime(booking.startDateTime)}</td>
                                                <td>{formatDateTime(booking.endDateTime)}</td>
                                                <td>
                                                    <span className={`badge ${
                                                        booking.status === 'CONFIRMED' ? 'badge-success' :
                                                        booking.status === 'PENDING' ? 'badge-warning' :
                                                        booking.status === 'CANCELLED' ? 'badge-danger' :
                                                        'badge-secondary'
                                                    }`}>
                                                        {booking.status === 'CONFIRMED' ? 'Confermato' :
                                                         booking.status === 'PENDING' ? 'In attesa' :
                                                         booking.status === 'CANCELLED' ? 'Annullato' :
                                                         booking.status}
                                                    </span>
                                                </td>
                                                <td>{booking.courseName || 'N/A'}</td>
                                                <td>{booking.coachName || 'N/A'}</td>
                                                <td>{booking.venueName || 'N/A'}</td>
                                                <td>{booking.notes || 'N/A'}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>
            )
        },
        {
            id: "presenze",
            name: "Presenze",
            content: (
                <Card>
                    <Card.Header><h4 className="card-title">Presenze della squadra</h4></Card.Header>
                    <Card.Body>
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <i className="fa fa-users fa-3x text-muted"></i>
                            </div>
                            <h5 className="text-muted">Nessuna presenza</h5>
                            <p className="text-muted">Le presenze dei componenti della squadra verranno visualizzate qui.</p>
                        </div>
                    </Card.Body>
                </Card>
            )
        }
    ];

    return (
        <>
            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-12">

                    <div className="custom-tab-1">
                        <Tab.Container defaultActiveKey="informazioni">
                            <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                                {tabData.map((data, i) => (
                                    <Nav.Item as="li" key={i} className="tabMenu">
                                        <Nav.Link 
                                            eventKey={data.id.toLowerCase()}
                                            onClick={data.id === 'membri' ? fetchMembers : data.id === 'pianificazione' ? fetchSlotBookings : undefined}
                                        >
                                            {data.name}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <Row className="align-items-start mt-4">
                                <div className="col-xl-9">
                                    <Tab.Content>
                                        {tabData.map((data, i) => (
                                            <Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
                                                {data.content}
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </div>
                                <div className="col-xl-3">
                                    <Card>
                                        <Card.Body className="text-left">
                                            <div>
                                                <h5 className="mb-3">Informazioni Squadra</h5>
                                                <p className="mb-2">
                                                    <strong>Informazioni generali:</strong> Visualizza tutti i dettagli della squadra selezionata, inclusi nome, staff tecnico, impianto e numero di membri.
                                                </p>
                                                <p className="mb-2">
                                                    <strong>Membri:</strong> Consulta l'elenco completo dei membri della squadra con i loro ruoli (PLAYER/JUNIOR).
                                                </p>
                                                <p className="mb-0">
                                                    <strong>Pianificazione:</strong> Visualizza gli orari settimanali e la programmazione delle attività della squadra.
                                                </p>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </Row>

            {/* Add Member Modal */}
            <Modal show={addMemberModalShowed} onHide={() => setAddMemberModalShowed(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Aggiungi Membro alla squadra</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {availableUsers.length === 0 ? (
                        <p>Nessun utente disponibile per questo corso.</p>
                    ) : (
                        <>
                            <Form.Label htmlFor="ct-utente">Utente da aggiungere alla squadra *</Form.Label>
                            <Form.Select 
                                id="ct-utente"
                                value={selectedUserId} 
                                onChange={(e) => setSelectedUserId(e.target.value)}
                                className="mb-3"
                            >
                                <option value="">Seleziona un utente...</option>
                                {availableUsers.map((userCourse) => {
                                    const userId = userCourse.juniorId || userCourse.playerId;
                                    const displayName = userCourse.juniorId 
                                        ? `${userCourse.juniorName} (Junior)`
                                        : userCourse.playerName;
                                    
                                    return (
                                        <option key={userId} value={userId}>
                                            {displayName || 'Nome non disponibile'}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={() => setAddMemberModalShowed(false)}
                        disabled={addingMember}
                    >
                        Annulla
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={addMemberToTeam}
                        disabled={addingMember || availableUsers.length === 0}
                    >
                        {addingMember ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Aggiungendo...
                            </>
                        ) : (
                            'Aggiungi Membro'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AdminUserCoursesTeamsView;